import App from "./App.svelte";

const app = new App({
  target: document.querySelector("#altTagRoot"),
});

export default app;
